import React from 'react';
import Radium from 'radium';
import { Link } from 'react-router-dom';

import styles from './ServicesStyle';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import MailCapture from '../../components/Mail/Mail';

class Blog extends React.Component {
    render() {
        return (
            <div>
                <Navbar />
                <div className="container" style={styles.container}>
                    <div className="row">
                        <div className="col-xs-12 text-center" style={{ marginBottom: 50 }}>
                            <h1 style={styles.servicesHeaderMain}>OUR SERVICES</h1>
                        </div>
                    </div>
                    <div className="row" style={{ marginBottom: 50 }}>
                        <div className="col-md-2 hidden-xs hidden-sm">
                            <a style={styles.servicesLink} href="#enterprise">For Enterprise</a>
                            <a style={styles.servicesLink} href="#executives">For Executives</a>
                        </div>
                        <div className="col-md-10 col-xs-12">
                            <div id="enterprise">
                                <h3 style={styles.servicesHeader}>Enterprise Services</h3>

                                <h4>Advisory service in IT infrastructure Services</h4>
                                <ul style={styles.serviceList}>
                                    <li>Improving the win ratio of deals</li>
                                    <li>Increasing margins by focused initiatives on cost optimization</li>
                                    <li>Enhancing customer satisfaction through a series of programs</li>
                                </ul>
                                <div style={styles.serviceDetailLinkDiv}>
                                    <Link to="/service/advisory" style={styles.serviceDetailLink}>
                                        Know more about our advisory services
                                    <i style={{ marginLeft: 10 }} className="fa fa-arrow-right"></i>
                                    </Link>
                                </div>

                                <h4>Work Force Planning and Development</h4>
                                <ul style={styles.serviceList}>
                                    <li>Enhancing the capabilities of junior and middle management through customized development programs</li>
                                    <li>Improving recruitment strategies for hiring niche talent across the globe</li>
                                    <li>Enhancing employee engagement and retention</li>
                                    <li>Improving the training strategy to minimize the learning curve</li>
                                </ul>
                                <div style={styles.serviceDetailLinkDiv}>
                                    <Link to="/service/workforce" style={styles.serviceDetailLink}>
                                        Know more about our work force planning and development services
                                    <i style={{ marginLeft: 10 }} className="fa fa-arrow-right"></i>
                                    </Link>
                                </div>
                            </div>



                            <div id="executives" style={styles.executiveDiv}>
                                <h3 style={styles.servicesHeader}>Executive Services</h3>
                                <h4>Executive Develpment Services</h4>
                                <ul style={styles.serviceList}>
                                    <li>Assessing strengths, improvement areas and areas which may prevent future growth</li>
                                    <li>Developing a personal development plan to reinforce strengths and improve the areas which need attention</li>
                                    <li>Coaching and mentoring to improve focus areas</li>
                                </ul>
                                <div style={styles.serviceDetailLinkDiv}>
                                    <Link to="/service/executive-development" style={styles.serviceDetailLink}>
                                        Know more about our executive development services
                                    <i style={{ marginLeft: 10 }} className="fa fa-arrow-right"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-10" style={{ marginBottom: 30, marginTop: 50 }}>
                        <MailCapture />
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Radium(Blog);


// WEBPACK FOOTER //
// ./src/containers/Services/Services.js